// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XN6a","left":"styles_left__BpV1l"};